'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    ticker: context.getElement('.' + context.className + '_Ticker'),
    mobileMenu: (0, _functional.getElement)('.hd-Header_MobileMenu')
  };
  if (!els.ticker) return;

  var isTicking = false;
  var lastKnownY = window.pageYOffset;
  var tickerHeight = els.ticker.offsetHeight;

  setupListeners();

  function setupListeners() {
    window.addEventListener('scroll', onScroll);
  }

  function onScroll() {
    lastKnownY = window.pageYOffset;

    requestTick();
  }

  function requestTick() {
    if (!isTicking) requestAnimationFrame(updateEl);

    isTicking = true;
  }

  function updateEl() {
    isTicking = false;

    els.el.classList.toggle('hd-Header-hideTicker', lastKnownY > tickerHeight);
    els.mobileMenu.classList.toggle('hd-Header-hideTicker', lastKnownY > tickerHeight);
  }
}